import { useCallback } from 'react';

import { api } from '@shared/api';
import { TimesEnum } from '@shared/enums';
import { UserStore } from '@shared/store';

import { useQuery } from '@tanstack/react-query';

import { useSwyftxMargin } from '../useSwyftxMargin';

const useFetchMarginAccounts = () => {
  const { getUniqueIdentifier } = UserStore.useUserStore;
  const { swyftxMarginEnabled } = useSwyftxMargin();

  const fetchAccounts = useCallback(async () => {
    if (!getUniqueIdentifier()) return;

    let response = await api.endpoints.getMarginAccounts({
      params: { swyftxUserId: getUniqueIdentifier() },
    });

    return response.data;
  }, [getUniqueIdentifier]);

  return useQuery({
    queryKey: ['margin-accounts', getUniqueIdentifier()],
    queryFn: fetchAccounts,
    keepPreviousData: true,
    staleTime: TimesEnum.MINUTE * 60,
    networkMode: 'always',
    enabled: swyftxMarginEnabled,
    retry: false,
  });
};

export { useFetchMarginAccounts };
